/*
 *
 * NewsHomePopups
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 19-Mar-2025
*/

import NewsHomePopups from './NewsHomePopupsContainer'

export default NewsHomePopups
